import { GetStaticProps, NextPage } from 'next';
import { SSRConfig, useTranslation } from 'next-i18next';
import i18nextConfig from 'next-i18next.config';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import tw, { styled } from 'twin.macro';
import { googleFormUrl } from 'core/view/Gnb';

const InnerBox = styled.div`
  ${tw`max-w-[1024px] mx-auto px-[24px] md:px-[80px] box-content`}
`;

const Association: NextPage = () => {
  const { t, i18n } = useTranslation('news');
  const lang = i18n.resolvedLanguage;

  return (
    <>
      <InnerBox>
        <div css={[tw`h-[80px] md:h-[100px]`]} />
        <header
          css={[tw`flex flex-col text-center gap-[12px]`, tw`line-height[1]`]}
        >
          {t('header.subInfo') && (
            <span
              css={[
                tw`text-[18px] text-[#333] font-extrabold font-NanumSquare`,
              ]}
            >
              {t('header.subInfo')}
            </span>
          )}
          <span
            css={[
              tw`text-[38px] text-[#111] font-bold font-OpenSans`,
              tw`text-transform[uppercase]`,
            ]}
          >
            NEWS
          </span>
        </header>

        <div css={[tw`h-[60px] md:h-[100px]`]} />

        <section>
          {[
            {
              date: '2023.02.22',
              title: t('section1.title'),
              contents: (
                <>
                  <img
                    src={`${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/news/1.jpeg`}
                    alt=""
                    css={[tw`mb-[24px]`]}
                  />
                  {t('section1.desc')}
                  <a
                    href={googleFormUrl(lang)}
                    target="_blank"
                    rel="noreferrer"
                    css={[tw`font-medium underline`]}
                  >
                    {t('section1.join')}
                  </a>
                </>
              ),
            },
          ].map(
            (
              obj: {
                date: string;
                title: string;
                contents: React.ReactNode;
              },
              i,
            ) => {
              return (
                <article
                  key={i}
                  css={[
                    tw`py-[12px] px-[24px] md:py-[20px] md:px-[40px]`,
                    tw`rounded-[10px]`,
                    tw`box-shadow[0px 4px 12px rgba(0, 0, 0, 0.15)]`,
                  ]}
                >
                  <button
                    css={[
                      tw`text-left`,
                      tw`flex items-center justify-between`,
                      tw`w-full`,
                    ]}
                  >
                    <div>
                      <span
                        css={[
                          tw`text-[13px] md:text-[14px] text-[#666] line-height[1.8em]`,
                          tw`font-OpenSans`,
                        ]}
                      >
                        {obj.date}
                      </span>
                      <header
                        css={[
                          tw`text-[17px] md:text-[20px] break1280:text-[24px] font-weight[800]  line-height[1.8em] text-[#111]`,
                          tw`font-NanumSquare`,
                        ]}
                      >
                        {obj.title}
                      </header>
                    </div>

                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      css={[tw`rotate-180`]}
                    >
                      <circle cx="18" cy="18.5" r="18" fill="#F6F6F6" />
                      <path
                        d="M12 15.5L18 21.5L24 15.5"
                        stroke="#AAAAAA"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                  <article
                    css={[
                      tw`text-[14px] md:text-[16px] break1280:text-[18px] line-height[2em]`,
                      tw`mt-[30px] text-[#333] pb-[30px] whitespace-pre-line`,
                    ]}
                  >
                    {obj.contents}
                  </article>
                </article>
              );
            },
          )}
        </section>
      </InnerBox>

      <div css={[tw`h-[120px] md:h-[160px]`]} />
    </>
  );
};

export default Association;

export const getStaticProps: GetStaticProps<SSRConfig> = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(
        locale as string,
        ['home', 'news'],
        i18nextConfig,
      )),
    },
  };
};
